/**
 * 패널 제품 관련 상수 정의
 */

// 셀 타입 상수 (백엔드 enum과 일치)
export const PANEL_PRODUCT_CELL_TYPES_CODE = {
  MONO: 1,
  POLY: 2,
  PERC: 3,
  TOPCON: 4,
  HJT: 5,
  IBC: 6,
  BIFACIAL: 7,
  THIN_FILM: 8,
  SHINGLED: 9
};

// 셀 타입 라벨 (백엔드 enum의 label과 일치)
export const PANEL_PRODUCT_CELL_TYPE_LABELS = {
  [PANEL_PRODUCT_CELL_TYPES_CODE.MONO]: 'Mono-Si',
  [PANEL_PRODUCT_CELL_TYPES_CODE.POLY]: 'Poly-Si',
  [PANEL_PRODUCT_CELL_TYPES_CODE.PERC]: 'PERC-Si',
  [PANEL_PRODUCT_CELL_TYPES_CODE.TOPCON]: 'TOPCON-Si',
  [PANEL_PRODUCT_CELL_TYPES_CODE.HJT]: 'HJT-Si',
  [PANEL_PRODUCT_CELL_TYPES_CODE.IBC]: 'IBC-Si',
  [PANEL_PRODUCT_CELL_TYPES_CODE.BIFACIAL]: 'Bifacial-Si',
  [PANEL_PRODUCT_CELL_TYPES_CODE.THIN_FILM]: 'Thin-Film',
  [PANEL_PRODUCT_CELL_TYPES_CODE.SHINGLED]: 'Shingled-Si'
};

// 셀 타입 한국어 라벨
export const PANEL_PRODUCT_CELL_TYPE_KOREAN_LABELS = {
  [PANEL_PRODUCT_CELL_TYPES_CODE.MONO]: '단결정 실리콘',
  [PANEL_PRODUCT_CELL_TYPES_CODE.POLY]: '다결정 실리콘',
  [PANEL_PRODUCT_CELL_TYPES_CODE.PERC]: 'PERC 셀',
  [PANEL_PRODUCT_CELL_TYPES_CODE.TOPCON]: 'TOPCON 셀',
  [PANEL_PRODUCT_CELL_TYPES_CODE.HJT]: 'HJT 셀',
  [PANEL_PRODUCT_CELL_TYPES_CODE.IBC]: 'IBC 셀',
  [PANEL_PRODUCT_CELL_TYPES_CODE.BIFACIAL]: '양면형 셀',
  [PANEL_PRODUCT_CELL_TYPES_CODE.THIN_FILM]: '박막형 셀',
  [PANEL_PRODUCT_CELL_TYPES_CODE.SHINGLED]: '싱글드 셀'
};

// 셀 타입 옵션 (select 컴포넌트용) - 영문/한국어 모두 표시
export const PANEL_PRODUCT_CELL_TYPE_OPTIONS = Object.entries(PANEL_PRODUCT_CELL_TYPE_LABELS).map(([value, label]) => ({
  value: parseInt(value),
  label: `${label} (${PANEL_PRODUCT_CELL_TYPE_KOREAN_LABELS[parseInt(value)]})`
}));

// 기본 패널 제품 데이터 구조
export const DEFAULT_PANEL_PRODUCT = {
  id: null,
  modelName: '',
  maker: '',
  maxPowerOutput: null,
  width: null,
  height: null,
  panelProductCellType: null,
  // 추가된 필드들
  maxVoltage: null,
  maxCurrent: null,
  openCircuitVoltage: null,
  shortCircuitCurrent: null,
  weight: null,
  thickness: null,
  warrantyPeriodYears: null,
  // 새로 추가된 필드들
  numberOfCells: null,
  cellEfficiency: null,
  operatingTempMin: null,
  operatingTempMax: null,
  ipRating: ''
};

// 테이블 헤더 정의
export const PANEL_PRODUCT_TABLE_HEADERS = [
  { text: '이미지', value: 'productImagePath', sortable: false, width: '80px' },
  { text: '모델명', value: 'modelName', sortable: true },
  { text: '제조사', value: 'maker', sortable: true },
  { text: '최대전력(W)', value: 'maxPowerOutput', sortable: true },
  { text: '크기(mm)', value: 'dimensions', sortable: false },
  { text: '최대전압(V)', value: 'maxVoltage', sortable: true },
  { text: '최대전류(A)', value: 'maxCurrent', sortable: true },
  { text: '개방전압(V)', value: 'openCircuitVoltage', sortable: true },
  { text: '단락전류(A)', value: 'shortCircuitCurrent', sortable: true },
  { text: '무게(kg)', value: 'weight', sortable: true },
  { text: '두께(mm)', value: 'thickness', sortable: true },
  { text: '보증기간(년)', value: 'warrantyPeriodYears', sortable: true },
  { text: '셀 개수', value: 'numberOfCells', sortable: true },
  { text: '셀 효율(%)', value: 'cellEfficiency', sortable: true },
  { text: '작동온도(°C)', value: 'operatingTemp', sortable: false },
  { text: 'IP 등급', value: 'ipRating', sortable: true },
  { text: '셀타입', value: 'panelProductCellType', sortable: true },
  { text: '수정/삭제', value: 'actions', sortable: false, align: 'center', width: '120px' }
];

/**
 * 좁은 화면/기본 목록용 필수 컬럼.
 * 상세 스펙은 수정 다이얼로그에서 보고, 목록은 식별·핵심 스펙만 유지한다.
 */
export const PANEL_PRODUCT_COMPACT_COLUMN_VALUES = Object.freeze([
  'productImagePath',
  'modelName',
  'maker',
  'maxPowerOutput',
  'dimensions',
  'panelProductCellType',
  'actions'
]);

/** 목록 썸네일: compact / 전체 컬럼 모드 */
export const PANEL_PRODUCT_IMAGE_SIZE = Object.freeze({
  compact: 72,
  full: 120
});
